import { render } from "./EventsDataTable.vue?vue&type=template&id=3dbf49a3&scoped=true"
import script from "./EventsDataTable.vue?vue&type=script&lang=js"
export * from "./EventsDataTable.vue?vue&type=script&lang=js"

import "./EventsDataTable.vue?vue&type=style&index=0&id=3dbf49a3&scoped=true&lang=css"
import "./EventsDataTable.vue?vue&type=style&index=1&id=3dbf49a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbf49a3"]])

export default __exports__